module.exports = __webpack_public_path__ + "assets/img/28985.webp?bb262474e6ba83baeda964007c49fc9a";